import { useDrawerState } from '../model/drawerState'
import { Modal } from '@bedrock/components'

export const blockDrawerClose = (onOk: () => any) => {
  const { isDrawerEditing, setIsDrawerEditing, blockModalConfig } = useDrawerState.getState()

  if (!isDrawerEditing) {
    return onOk?.()
  }

  return new Promise((resolve) => {
    Modal.warning({
      title: blockModalConfig?.title || '确定离开当前填写表单吗？',
      content: blockModalConfig?.content || '离开后，未提交的内容将会丢失',
      onOk: () => {
          onOk?.()
          setIsDrawerEditing(false)
          resolve(true)
        }
      })
  })
}
export default blockDrawerClose;
